import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=2f7db226&"
import script from "./sitemap.vue?vue&type=script&lang=js&"
export * from "./sitemap.vue?vue&type=script&lang=js&"
import style0 from "./sitemap.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./sitemap.vue?vue&type=style&index=1&scpoed=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports